import React, { ReactNode, useState } from 'react';
import ExpandBox from '../../components/ExpandBox';
import { MdOutlineAddCircleOutline, MdRemoveCircleOutline } from 'react-icons/md';

export default function ToKnowAboutSM(props: { children: ReactNode; header: string }) {
    const [show, setShow] = useState<boolean>(false);
    return (
        <div className={'ml-auto mr-auto w-full border-t py-5 md:w-1/2'}>
            <ExpandBox
                show={show}
                header={
                    <div
                        onClick={() => setShow(!show)}
                        className={
                            'flex cursor-pointer items-center justify-between gap-2 font-medium'
                        }>
                        <p>{props.header}</p>
                        <span className={'hover-effect text-2xl text-SM-yellow'}>
                            {show ? <MdRemoveCircleOutline /> : <MdOutlineAddCircleOutline />}
                        </span>
                    </div>
                }>
                <p className={'my-5 text-sm'}>{props.children}</p>
            </ExpandBox>
        </div>
    );
}
